import * as Sentry from '@sentry/react';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { env } from '@/lib/env';

interface State {
	access_token: string | null;
	id_token: string | null;
	refresh_token: string | null;
	user?: unknown;
}

interface Action {
	onLogin: (token: NonNullable<StrictOmit<State, 'user'>>) => void;
	setStore: (key: keyof State, data: State[typeof key]) => void;
	logout: () => void;
}

export const useAuthStore = create<State & Action>()(
	devtools(
		persist(
			immer((set, get) => ({
				access_token: null,
				refresh_token: null,
				id_token: null,
				onLogin: (token) => set({ ...token }),
				setStore: (key, data) => set({ [key]: data }),
				logout: () => {
					Sentry.setUser(null);
					const idToken = get().id_token;

					if (!idToken) {
						set({ access_token: null, refresh_token: null, id_token: null });
						return;
					}

					const params = new URLSearchParams({
						id_token_hint: idToken,
						post_logout_redirect_uri: env.VITE_DUENDE_REDIRECT_URI_LOGOUT
					});
					const fullLogoutUrl = `${env.VITE_DUENDE_URL}/connect/endsession?${params.toString()}`;

					set({ access_token: null, refresh_token: null, id_token: null });
					globalThis.location.assign(fullLogoutUrl);
				}
			})),
			{
				name: 'circle-auth'
			}
		)
	)
);
